<template>
  <section class="main-banner__wrapper">
    <div class="main-banner">
      <div class="main-banner__cheap">
        <span>русский язык</span>
        <span>литература</span>
        <span>5–11 классы</span>
      </div>
      <h1 class="main-banner__subtitle">
        гуманитарный класс в&nbsp;домашней школе
      </h1>
      <h2 class="main-banner__title">
        это&nbsp;будущее ребенка в&nbsp;социальных науках и&nbsp;таких&nbsp;профессиях,
        как&nbsp;копирайтер, учитель, писатель и&nbsp;других специальностях
      </h2>
      <button
        class="main-banner__btn m-btn"
        @click="openModal(MODAL_TYPES.gymClass)"
      >
        записаться в класс
      </button>
    </div>

    <school-new-banner-blocks />
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../common/AppHeader/data';

import SchoolNewBannerBlocks from './SchoolNewBannerBlocks.vue';

export default {
  name: 'GymBanner',
  components: { SchoolNewBannerBlocks },
  data: () => ({
    MODAL_TYPES,
  }),
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style lang="scss" scoped>

.main-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(var(--scale) * 720);
  padding: calc(var(--scale) * 40);
  border-radius: calc(var(--scale) * 60);

  background-image: url("/v2/school-new/gym/banner.webp");
  background-size: 100% 100%;
  background-position: center;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 512);
    padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/school-new/gym/banner-tablet.webp");
  }

  @include media-down($size-mobile) {
    padding-top: calc(var(--scale) * 12);
    height: calc(var(--scale) * 720);
    background-image: url("/v2/school-new/gym/banner-mob.webp");
  }

  &__cheap {
    margin-bottom: calc(var(--scale) * 16);
    display: flex;
    gap: calc(var(--scale) * 4);

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 10);
      margin-bottom: calc(var(--scale) * 12);
      gap: calc(var(--scale) * 2);
      flex-wrap: wrap;
    }

    span {
      padding: calc(var(--scale) * 9) calc(var(--scale) * 19);
      background-color: rgba(#FFFFFF, 0.01);
      border: 1px solid rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10px);
      border-radius: calc(var(--scale) * 40);

      font-style: normal;
      font-weight: 400;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      color: #FFFFFF;
      white-space: nowrap;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 6) calc(var(--scale) * 11);
        font-size: calc(var(--scale) * 14);
      }
    }
  }

  &__subtitle  {
    max-width: calc(var(--scale) * 1025);
    margin-bottom: calc(var(--scale) * 32);

    font-weight: 500;
    font-size: calc(var(--scale) * 120);
    line-height: 80%;
    letter-spacing: -0.08em;
    text-transform: lowercase;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 10);
      margin-bottom: calc(var(--scale) * 12);
      max-width: calc(var(--scale) * 480);
      font-size: calc(var(--scale) * 62);
      line-height: 75%;
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 44);
      letter-spacing: -0.06em;
    }
  }

  &__title {
    max-width: calc(var(--scale) * 890);

    font-weight: 500;
    font-size: calc(var(--scale) * 28);
    line-height: 110%;
     color: #FFFFFF;

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 10);
      max-width: calc(var(--scale) * 480);
      font-size: calc(var(--scale) * 18);
      letter-spacing: -0.02em;
    }
  }

  &__btn {
    margin-top: auto;
    padding: calc(var(--scale) * 44) calc(var(--scale) * 56);
    background-color: #5237E6;
    border-radius: calc(var(--scale) * 40);
    transition: 200ms;

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 30);
      width: 100%;
      border-radius: calc(var(--scale) * 24);
      font-size: calc(var(--scale) * 18);
      letter-spacing: -0.02em;
    }

    @media (hover: hover) {
      &:hover {
        background-color: #846EFB;
      }
    }
  }
}

</style>
